// Mock PlatformPay namespace
export var PlatformPay;
(function (PlatformPay) {
    PlatformPay.PaymentType = {
        Immediate: 'immediate',
        Recurring: 'recurring',
    };
    PlatformPay.IntervalUnit = {
        Month: 'month',
        Year: 'year',
    };
})(PlatformPay || (PlatformPay = {}));
// Mock functions that return successful responses
export const confirmPayment = async () => ({
    paymentIntent: { status: 'succeeded' },
    error: null,
});
export const handleNextAction = async () => ({
    paymentIntent: { status: 'succeeded' },
    error: null,
});
export const handleNextActionForSetup = async () => ({
    setupIntent: { status: 'succeeded' },
    error: null,
});
export const initPaymentSheet = async () => ({
    error: null,
});
export const initStripe = async () => ({
    error: null,
});
export const presentPaymentSheet = async () => ({
    error: null,
});
export const retrieveSetupIntent = async () => ({
    setupIntent: { status: 'succeeded' },
    error: null,
});
// Mock hook that returns platform pay support
export const usePlatformPay = () => ({
    confirmPlatformPaySetupIntent: async () => ({
        error: null,
    }),
    isPlatformPaySupported: async () => false,
});
export const useStripe = () => ({
    handleURLCallback: async () => false,
});
